import auth from "../../configs/auth";

/**
 * Logout the application.
 */
export default function()
{
    sessionStorage.clear() ;
    localStorage.clear() ;
    window.location = auth.logout_url + "?redirect_uri=" + auth.homepage ;
}


// WEBPACK FOOTER //
// ./src/app/net/auth/logout.js